module.exports = __webpack_public_path__ + "img/icon-facebook.4a03801e.svg";